export default __webpack_public_path__ + "static/media/AthenumPrivacyPolicy_2022July.4d9d3221.pdf";